/**
 * @name ProjectRouteController
 * @description Controller called to display/manage projects and appts
 * @param {angular} $log The Angular $log service
 * @param {angular} $stateParams The Angular $log service
 */
function ProjectRouteController(
  $log,
  $stateParams
) {
  let vm = this;
  vm.$onInit = function() {
    vm.updateProject = updateProject;
  };

  /**
   * @name updateProject
   * @description Function to update the project object after it's changed
   * @param {object} project The project update
   */
  function updateProject(project) {
    vm.project = project;
  }

  $log.debug('Project from project route: ', vm.project);
}

angular
  .module('inkfinder')
  .controller('ProjectRouteController', ProjectRouteController);



// WEBPACK FOOTER //
// ./routes/project/project-route.controller.js